import * as React from 'react'
import { ParentSize } from '@vx/responsive'
import InfoCard from 'components/Cards/InfoCard'
import { flow, groupBy, map } from 'lodash/fp'
import { GraphLineCompare } from 'features/CallAnalytics/GraphLineCompare'
import { moment } from 'features/Moment'
import { unitOfTime } from 'moment'
import { unionBy, orderBy, uniqBy } from 'lodash'
import { ICall, IPeriodUnit, IDateVal } from '../../types'
import Button from 'components/Button'
import * as sMarg from 'styles/modules/margins.scss'
import { mapWithKey } from '../../../../utils/lodash'

const formatData = (data: ICall[], sumPeriod: unitOfTime.StartOf): IDateVal[] =>
  flow<ICall[], any, any, IDateVal[]>(
    map((call: ICall) => ({
      ...call,
      dateTime: moment(call.dateTime)
        .local()
        .startOf(sumPeriod)
        .format(),
    })),
    groupBy('dateTime'),
    mapWithKey(items => ({
      date: items[0].dateTime,
      value: items.length,
    }))
  )(data)

const add1Period = (data, periodValue, periodUnit) =>
  data.map(call => ({
    ...call,
    dateTime: moment(call.dateTime)
      .add(periodValue, periodUnit)
      .format(),
  }))

export interface ICallsTrendsVolumeProps {
  calls: ICall[]
  callsPrevious: ICall[]
  dateInterval: string[]
  sumPeriod: IPeriodUnit
  periodValue: number
  periodUnit: string
  dateFormat: string
  loading: boolean
  height?: number
  className?: string
  to?: string
  toText?: string
  overlayText?: string
}

export class CallsTrendsVolume extends React.Component<ICallsTrendsVolumeProps> {
  state = {
    uniqueCallers: false,
  }
  setUniqueCallers = status => () =>
    this.setState({
      uniqueCallers: status,
    })
  render() {
    const {
      calls,
      callsPrevious,
      dateInterval,
      sumPeriod,
      periodValue,
      periodUnit,
      dateFormat,
      loading,
      height = 400,
      className,
      to,
      toText,
      overlayText,
    } = this.props
    const { uniqueCallers } = this.state
    const callsUniqued = uniqueCallers ? uniqBy(calls, 'incomingCaller') : calls
    const callsPreviousUniqued = uniqueCallers
      ? uniqBy(callsPrevious, 'incomingCaller')
      : callsPrevious
    const baseData = dateInterval.map(date => ({ date, value: 0 }))
    const data1Raw = formatData(callsUniqued, sumPeriod)
    const data2Raw = formatData(
      add1Period(callsPreviousUniqued, periodValue, periodUnit),
      sumPeriod
    )
    const data1 = orderBy(unionBy(data1Raw, baseData, 'date'), 'date')
    const data2 = orderBy(unionBy(data2Raw, baseData, 'date'), 'date')

    const toggleButtons = (
      <div>
        <Button
          className={sMarg.mr15}
          size="xs"
          ghost
          style={uniqueCallers ? { borderColor: 'transparent' } : {}}
          onClick={this.setUniqueCallers(false)}
        >
          All callers
        </Button>
        <Button
          size="xs"
          ghost
          style={!uniqueCallers ? { borderColor: 'transparent' } : {}}
          onClick={this.setUniqueCallers(true)}
          title="Repeat callers will only be counted once"
        >
          Unique callers
        </Button>
      </div>
    )

    return (
      <InfoCard
        style={{ height: '100%' }}
        title="Call volume"
        loading={loading}
        className={className}
        allowOverflow={!toText}
        to={to}
        toText={toText}
        overlayText={overlayText}
        titleRight={toggleButtons}
      >
        <ParentSize>
          {({ width }) => (
            <GraphLineCompare
              width={width}
              height={height}
              data1={data1}
              data2={data2}
              label="Calls"
              dateFormat={dateFormat}
            />
          )}
        </ParentSize>
      </InfoCard>
    )
  }
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsTrendsVolume/CallsTrendsVolume.tsx